import React from "react";

import isArray from "lodash/isArray";

import { Species, SpeciesType } from "constants/species";

import { useResolveSpeciesId } from "hooks";

interface ForSpeciesProps {
  children: React.ReactNode;
  species: SpeciesType | SpeciesType[];
  selectedSpeciesId?: number | null;
}

export const ForSpecies = React.memo(
  ({
    children,
    species,
    selectedSpeciesId,
  }: ForSpeciesProps): React.ReactNode => {
    const speciesId = useResolveSpeciesId(selectedSpeciesId);

    let visible = false;
    if (isArray(species)) {
      visible = species.includes(speciesId);
    } else if (typeof species === "number") {
      visible = species === speciesId;
    }
    return visible ? children : null;
  },
);

interface ForSpeciesShorthandProps {
  children: React.ReactNode;
  selectedSpeciesId?: number | null;
}

export const ForSheep = ({
  children,
  selectedSpeciesId = undefined,
}: ForSpeciesShorthandProps): React.ReactNode => (
  <ForSpecies species={[Species.SHEEP]} selectedSpeciesId={selectedSpeciesId}>
    {children}
  </ForSpecies>
);

export const ForCattle = ({
  children,
  selectedSpeciesId = undefined,
}: ForSpeciesShorthandProps): React.ReactNode => (
  <ForSpecies species={[Species.CATTLE]} selectedSpeciesId={selectedSpeciesId}>
    {children}
  </ForSpecies>
);

export default ForSpecies;
